import { mixin, vars } from '@src/services/theme';

export const amCharts = `
.amcharts-chart-div a {
    display:none !important;
}
`;

export const reactTable = `
.ReactTable {
    border: none;

    > .rt-table {
        > .rt-thead {
            &.-header {
                box-shadow: none;
                > .rt-tr {
                    > .rt-th {
                        text-align: center;
                        font-weight: normal;
                        background: #d4d3d3;
                        padding: 15px 5px;
                        border: 1px solid #e5e3e3;
                    }
                }
            }
            &.-headerGroups {
                > .rt-tr {
                    > .rt-th {
                        color: ${vars.colors.white};
                        background-color: ${vars.colors.black};
                        padding: 5px;
                    }
                }
            }
        }
        > .rt-tbody {
            > .rt-tr-group {
                > .rt-tr {
                    > .rt-td {
                        padding: 8px 5px;
                        border: 1px solid #e5e3e3;
                        font-size: 15px;

                        &.id, &.number, &.bullet {
                            text-align: center;
                        }
                    }
                }
            }
        }
    }

    .clickable {
        cursor: pointer;
        &:hover {
            background-color: ${vars.colors.greyLight};
        }
    }
    .disabled {
        color: ${vars.colors.red};
    }
}
`;

export const datePicker = `
.DateRangePicker_picker {
    z-index: 11 !important;
}
`;




// WEBPACK FOOTER //
// ./src/styles/fix.ts